import styled from "@emotion/styled";

export const Container = styled.div``;
export const TableContainer = styled.div`
  background-color: rgba(243, 245, 248, 1);
  border: 1px solid rgba(228, 231, 236, 1);
  border-radius: 16px;
`;
export const HeaderRow = styled.div`
  background-color: transparent;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding: 0px 34px;
  max-height: 52px;
`;

export const BodyContainer = styled.div`
  background-color: rgb(255, 255, 255);
  border: 1px solid rgba(228, 231, 236, 1);
  border-radius: 8px;
  margin: 0px 8px 8px 8px;
`;

export const Row = styled.div<{ removeHover?: boolean }>`
  border-bottom: 1px solid rgba(243, 244, 247, 1);
  cursor: ${(props) => (props.removeHover ? "default" : "pointer")};
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  height: 66px;
  padding: 0px 25px;
  transition: background-color 100ms ease-in-out;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${(props) =>
      props.removeHover ? "none" : "rgba(250, 251, 252, 1)"};
  }
`;

export const RowCell = styled.div``;
